var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'accordion__header' + _vm.botRounded},[_vm._v("\n    "+_vm._s(_vm.text ? _vm.text : 'El texto del header no ha sido colocado')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }